import { Grid } from '@mui/material';
import { BalanceBudgetGiftProcedure } from 'components/admin-portal/Procedures/LeaveProcedures/components/BalanceBudgetGiftProcedure';
//import { YearOverLeaveProcedure } from 'components/admin-portal/Procedures/LeaveProcedures/components/YearOverLeaveProcedure';

export const LeaveProcedures = () => {
  return (
    <Grid container spacing={3}>
      {/* <Grid item xs={4}>
        <YearOverLeaveProcedure />
      </Grid> */}
      <Grid item xs={4}>
        <BalanceBudgetGiftProcedure />
      </Grid>
    </Grid>
  );
};
